<template>
  <Icon>
    <svg
      slot="svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      :style="Number.isInteger(defaultRotation) ? { transform: `rotate(${defaultRotation}deg)` } : null"
     >
      <defs>
        <path d="M19.143,13.4 L22,13.4 L22,10.6 L19.143,10.6 L19.143,13.4 Z M13.429,12 C13.429,9.68 11.51,7.8 9.143,7.8 C6.776,7.8 4.857,9.68 4.857,12 C4.857,14.32 6.776,16.2 9.143,16.2 C11.51,16.2 13.429,14.32 13.429,12 Z M16.286,12 C16.286,15.865 13.088,19 9.143,19 C5.198,19 2,15.865 2,12 C2,8.134 5.198,5 9.143,5 C13.088,5 16.286,8.134 16.286,12 Z" id="path-source-path"></path>
      </defs>
      <g id="icons/source" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-source-path" fill="white">
          <use xlink:href="#path-source-path"></use>
        </mask>
        <use id="Page-1" fill="#000000" xlink:href="#path-source-path"></use>
        <g id="Mixin/Fill/Black" mask="url(#mask-source-path)" :fill="fill">
          <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from "./icon";

export default {
  name: "DsSourcePathIcon",
  props: {
    fill: {
      type: String,
      default: '#8b97ab'
    },
    defaultRotation: {
      type: Number,
      default: null
    }
  },
  components: {
    Icon
  },
  extends: Icon
};
</script>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-source-path-icon.vue